<template>
  <div class="role_warp">
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-delete"
        @click="bulkDelete"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getList"
      >刷新</el-button>
    </div>

    <div class="head_search">
      <div class="item_warp">
        <span>名称</span>
        <el-input
          v-model.trim="searchName"
          size="mini"
          clearable
          style="width: 180px; margin-left: 8px"
          placeholder="请输入名称"
        />
      </div>
      <el-button type="primary" size="mini" class="edit-button" @click="doFilter">
        筛选
      </el-button>
    </div>

    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="filteredList"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1531px"
      height="calc(100vh - 240px)"
      size="mini"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="crmCode" label="CRM编号" width="170" />
      <el-table-column prop="name" label="名称" width="170" />
      <el-table-column label="图标" width="120">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.iconUrl"
            fit="contain"
            style="width: 40px; height: 40px"
            :preview-src-list="toArrayEvent(scope.row.iconUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column label="图片" width="120">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.imageUrl"
            fit="contain"
            style="width: 40px; height: 40px"
            :preview-src-list="toArrayEvent(scope.row.imageUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column label="权益列表" width="280">
        <template slot-scope="scope">
          <div>{{ formatBenefitList(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="100" />
      <el-table-column label="创建时间" width="220">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), '{y}-{m}-{d} {h}:{i}:{s}')
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="open('edit', scope.row)"
          >编辑</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="removeOne(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="isEdit ? '编辑' : '添加'"
      :visible.sync="dialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formRef"
        :model="formData"
        :rules="rules"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="会员编码" prop="crmCode">
          <el-select
            v-model="formData.crmCode"
            filterable
            clearable
            placeholder="请选择CRM会员编码"
            style="width: 300px"
            @change="handleCrmLevelChange"
          >
            <el-option
              v-for="item in crmLevelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model.trim="formData.name" style="width: 300px" />
        </el-form-item>
        <el-form-item label="图标" prop="iconUrl">
          <uploadPic
            :my-url="formData.iconUrl"
            :width="80"
            :height="80"
            :enable-preview-delete="true"
            @upLoadImage="(url) => handleUpload('iconUrl', url)"
          />
          <div class="upload_tip">个人中心展示图标</div>
        </el-form-item>
        <el-form-item label="图片" prop="imageUrl">
          <uploadPic
            :my-url="formData.imageUrl"
            :width="80"
            :height="80"
            :enable-preview-delete="true"
            @upLoadImage="(url) => handleUpload('imageUrl', url)"
          />
          <div class="upload_tip">会员权益中心展示图片</div>
        </el-form-item>
        <el-form-item label="权益" prop="benefitIds">
          <el-checkbox-group v-model="formData.benefitIds">
            <el-checkbox
              v-for="item in benefitOptions"
              :key="item.value"
              :label="item.value"
            >{{ item.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="formData.sort" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item>
          <el-button style="margin-right: 10px" @click="dialogVisible = false">
            取消
          </el-button>
          <el-popconfirm title="是否确定保存？" @onConfirm="isEdit ? edit() : add()">
            <el-button slot="reference" type="primary" class="edit-button">
              保存
            </el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import uploadPic from '@/components/Upload/UploadPic'
import {
  getMemberConfigList,
  addMemberConfig,
  updateMemberConfig,
  removeMemberConfig,
  getCrmMemberLevelList
} from '@/api/activity/memberConfig'
import { getMemberBenefitList } from '@/api/activity/memberBenefit'

function createDefaultForm() {
  return {
    id: '',
    crmCode: '',
    name: '',
    iconUrl: '',
    imageUrl: '',
    benefitIds: [],
    sort: 0
  }
}

function normalizeIds(ids) {
  if (Array.isArray(ids)) return ids.map((x) => Number(x)).filter((x) => x > 0)
  if (!ids) return []
  return String(ids)
    .split(',')
    .map((x) => Number(x.trim()))
    .filter((x) => x > 0)
}

export default {
  name: 'MemberConfig',
  components: { uploadPic },
  data() {
    return {
      loading: false,
      saveLoading: false,
      searchName: '',
      showtabelData: [],
      filteredList: [],
      multipleSelection: [],
      dialogVisible: false,
      isEdit: false,
      formData: createDefaultForm(),
      crmLevelOptions: [],
      benefitOptions: [],
      rules: {
        crmCode: [{ required: true, message: '请选择会员编码', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        iconUrl: [{ required: true, message: '请上传图标', trigger: 'change' }],
        imageUrl: [{ required: true, message: '请上传图片', trigger: 'change' }],
        benefitIds: [{ type: 'array', required: true, min: 1, message: '请至少选择一个权益', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    toArrayEvent(item) {
      return [item]
    },
    initPage() {
      this.loading = true
      Promise.all([
        getMemberConfigList(),
        getMemberBenefitList(),
        getCrmMemberLevelList()
      ])
        .then(([configRes, benefitRes, crmRes]) => {
          this.showtabelData = Array.isArray(configRes) ? configRes : []
          this.applyFilter()
          this.benefitOptions = (Array.isArray(benefitRes) ? benefitRes : []).map((item) => ({
            label: item.name,
            value: Number(item.id)
          }))
          this.crmLevelOptions = this.parseCrmLevels(crmRes)
        })
        .catch((err) => {
          this.$message.error(err || '服务端异常，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    parseCrmLevels(res) {
      const levelSource = res?.level || []
      return (Array.isArray(levelSource) ? levelSource : []).map((item) => ({
        label: item.name,
        value: String(item.code || ''),
        rawName: item.name
      }))
    },
    applyFilter() {
      const keyword = this.searchName.trim()
      if (!keyword) {
        this.filteredList = [...this.showtabelData]
        return
      }
      this.filteredList = this.showtabelData.filter((item) =>
        String(item.name || '').includes(keyword)
      )
    },
    doFilter() {
      this.applyFilter()
    },
    formatBenefitList(row) {
      const arr = Array.isArray(row.benefitList)
        ? row.benefitList
        : String(row.benefitNames || '')
            .split(',')
            .map((x) => x.trim())
            .filter(Boolean)
      return arr.length ? `[${arr.join('][')}]` : '-'
    },
    getList() {
      this.loading = true
      getMemberConfigList()
        .then((res) => {
          this.showtabelData = Array.isArray(res) ? res : []
          this.applyFilter()
        })
        .catch((err) => {
          this.$message.error(err || '服务端异常，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    open(type, row) {
      this.formData = createDefaultForm()
      if (type === 'add') {
        this.isEdit = false
      } else {
        this.isEdit = true
        this.formData = {
          id: row.id,
          crmCode: String(row.crmCode || ''),
          name: row.name || '',
          iconUrl: row.iconUrl || '',
          imageUrl: row.imageUrl || '',
          benefitIds: normalizeIds(row.benefitIds),
          sort: Number(row.sort) || 0
        }
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    handleCrmLevelChange(val) {
      this.formData.crmCode = String(val || '')
      const level = this.crmLevelOptions.find((item) => item.value === this.formData.crmCode)
      if (!this.formData.name && level) {
        this.formData.name = level.rawName || ''
      }
    },
    handleUpload(field, url) {
      this.formData[field] = url
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField(field)
      })
    },
    buildPayload() {
      return {
        id: this.formData.id,
        crmCode: String(this.formData.crmCode),
        name: this.formData.name,
        iconUrl: this.formData.iconUrl,
        imageUrl: this.formData.imageUrl,
        benefitIds: normalizeIds(this.formData.benefitIds).join(','),
        sort: Number(this.formData.sort)
      }
    },
    add() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        const payload = this.buildPayload()
        delete payload.id
        this.saveLoading = true
        addMemberConfig(payload)
          .then(() => {
            this.$message.success('添加成功')
            this.dialogVisible = false
            this.getList()
          })
          .catch((err) => {
            this.$message.error(err || '添加失败')
          })
          .finally(() => {
            this.saveLoading = false
          })
      })
    },
    edit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        const payload = this.buildPayload()
        this.saveLoading = true
        updateMemberConfig(payload)
          .then(() => {
            this.$message.success('更新成功')
            this.dialogVisible = false
            this.getList()
          })
          .catch((err) => {
            this.$message.error(err || '更新失败')
          })
          .finally(() => {
            this.saveLoading = false
          })
      })
    },
    removeOne(row) {
      this.$confirm('是否删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => removeMemberConfig({ ids: [row.id] }))
        .then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
        .catch(() => {})
    },
    bulkDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请勾选要删除的选项')
        return
      }
      this.$confirm('是否删除选中数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const ids = this.multipleSelection.map((item) => item.id)
          return removeMemberConfig({ ids })
        })
        .then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
}
.role_heard_tool {
  margin-bottom: 12px;
}
.head_search {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.item_warp {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.upload_tip {
  margin-top: 6px;
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}
</style>
